export const CUSTOM_TYPES = {
  debug: {
    url: '/debug',
    title: 'Debug',
  },
}
